import hero from '../../assets/images/hero.jpg';

function RegistrationHero() {
    return (
        <section className="hidden h-full min-h-0 md:flex md:w-1/2">
            <div className="w-full h-full flex items-center justify-center bg-custom-bg-hero">
                <img src={hero} alt="" className="w-full h-full object-contain" />
            </div>
        </section>
    );
}

export default RegistrationHero;
